import { render, staticRenderFns } from "./CalendarSidePanel.vue?vue&type=template&id=7bf8aacf&scoped=true"
import script from "./CalendarSidePanel.vue?vue&type=script&lang=js"
export * from "./CalendarSidePanel.vue?vue&type=script&lang=js"
import style0 from "./CalendarSidePanel.vue?vue&type=style&index=0&id=7bf8aacf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8aacf",
  null
  
)

export default component.exports